import React from 'react';
import PropTypes from 'prop-types';
import cx from "../utils/styles";
export var Day = function Day(_ref) {
  var date = _ref.date,
    _onClick = _ref.onClick,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? undefined : _ref$className;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('day', className),
    onClick: function onClick() {
      return _onClick(date);
    },
    "data-t-id": "Calendar-components"
  }, date.getDate());
};
Day.propTypes = process.env.NODE_ENV !== "production" ? {
  date: PropTypes.instanceOf(Date).isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
} : {};
Day.defaultProps = {
  className: undefined
};